import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
import { convertNameToId } from "../utils";
export default function useTranslatedLanguage() {
    const { t } = useTranslation();
    const translatedByLanguageId = useMemo(() => ({
        english: t("common:languages.english"),
        arabic: t("common:languages.arabic"),
        chinese: t("common:languages.chinese"),
        french: t("common:languages.french"),
        german: t("common:languages.german"),
        hindi: t("common:languages.hindi"),
        italian: t("common:languages.italian"),
        japanese: t("common:languages.japanese"),
        korean: t("common:languages.korean"),
        polish: t("common:languages.polish"),
        portuguese: t("common:languages.portuguese"),
        russian: t("common:languages.russian"),
        spanish: t("common:languages.spanish"),
        turkish: t("common:languages.turkish"),
    }), [t]);
    const getTranslatedLanguage = useCallback((name) => {
        if (!name)
            return "";
        const id = convertNameToId(name);
        return (translatedByLanguageId[id] ??
            name);
    }, [translatedByLanguageId]);
    return { getTranslatedLanguage };
}
